export const OrderLabelViewLabels = {
    courierLabels: 'Guías de paquetera',
    empty_string: '',
    labels: 'Información de guías',
    matchedGuides: 'Guías asociadas',
    noInfo: 'Sin información',
    percentage: '%',
    whiteLabels: 'Guías blancas',
  };
